var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _style, _path, _g, _g2, _path2, _g3, _g4, _g5, _g6;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTbAppIconAddRobot = function SvgTbAppIconAddRobot(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_12624",
    "data-name": "Group 12624",
    width: 24.26,
    height: 17.45,
    viewBox: "0 0 24.26 17.45",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("defs", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    className: "cls-1",
    d: "M35.737 25.664a.957.957 0 1 1 .987-.957.972.972 0 0 1-.987.957z",
    transform: "translate(-34.75 -23.75)"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_235",
    "data-name": "Rectangle 235",
    className: "cls-2",
    d: "M0 0h30v30H0z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    className: "cls-1",
    d: "M30.724 24.707a.987.987 0 1 1-.987-.957.972.972 0 0 1 .987.957",
    transform: "translate(-28.75 -23.75)"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M25.848 28.355c.1.572.225 1.137.35 1.683a9.794 9.794 0 0 0 1.471 3.677c.15.2.524.724.8.724l3.666.011 3.666-.011c.271 0 .645-.524.795-.724a9.794 9.794 0 0 0 1.471-3.677 38.1 38.1 0 0 0 .35-1.683l.146-.487a1.467 1.467 0 0 0 .7-1.172c0-.074.046-1.838-.422-1.457-.121.1-.866.752-1.061.881a7.705 7.705 0 0 1-2.487 1.044 14.216 14.216 0 0 1-3.159.409 14.254 14.254 0 0 1-3.159-.409 7.7 7.7 0 0 1-2.487-1.044c-.195-.129-.94-.783-1.061-.881-.473-.381-.427 1.383-.427 1.461a1.467 1.467 0 0 0 .7 1.172m6.43 4.758a.75.75 0 1 1 .777-.749.772.772 0 0 1-.777.749m0-2.275a.75.75 0 1 1 .777-.75.77.77 0 0 1-.777.75",
    transform: "translate(-25 -25.185)",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_239",
    "data-name": "Rectangle 239",
    style: {
      fill: "none"
    },
    d: "M0 0h30v30H0z"
  })), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    className: "cls-1",
    d: "M30.562 21.454a5.974 5.974 0 0 1 .233-1.646l.011-.031a4.584 4.584 0 0 1-2.495-2.027c-.317.085-1.771 1.534-2.561 5.144.98.671 3.087.284 4.92-.258a4.106 4.106 0 0 1-.108-1.182",
    transform: "translate(-25.75 -17.75)"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    className: "cls-1",
    d: "M35.5 20.41a8.538 8.538 0 0 1 1.685-.324.6.6 0 0 1 .352.084.782.782 0 0 1 .258.718 5.237 5.237 0 0 1-.312 1.426 12.84 12.84 0 0 1 1.645.78c-1.032-4.713-2.652-5.344-2.652-5.344.7.486-.227 1.984-.976 2.66",
    transform: "translate(-35.5 -17.75)"
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    className: "cls-1",
    d: "M31.772 18.56a.319.319 0 0 1 .077-.009c.131 0 .355.063 1.03.53.263.181.5.361.614.447H33.712A2.369 2.369 0 0 0 35.1 17.5a.806.806 0 0 0-.5-.493c-.12-.041-2.257.044-2.257.044h-.266s-2.1-.083-2.257-.044-.355.183-.315.264a5.453 5.453 0 0 0 1.995 1.496.466.466 0 0 1 .275-.207",
    transform: "translate(-29.5 -17)"
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    className: "cls-1",
    d: "M36.48 23.669a2.973 2.973 0 0 1-.828-.6 4.307 4.307 0 0 1-.722-.764l-.034-.134-.145-.012a2.259 2.259 0 0 1-.682-.138l-.169-.111-.114.156a5.907 5.907 0 0 1-1.931.752h-.02a5.451 5.451 0 0 1 .141-2.527c.085-.23.158-.281.179-.291a8.212 8.212 0 0 1 1.886 1.213l.074.058.094-.018a1.058 1.058 0 0 1 .178-.014.79.79 0 0 1 .453.122l.083.059.1-.03a11.628 11.628 0 0 1 2.13-.468.531.531 0 0 1 .09.006.542.542 0 0 1 .057.334 5.508 5.508 0 0 1-.822 2.407",
    transform: "translate(-31.75 -20)"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,.cls-2{fill:#e8e4da}.cls-1{clip-rule:evenodd}.cls-6{clip-path:url(#clip-path-2)}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1514",
    "data-name": "Path 1514",
    className: "cls-2",
    d: "M6 10V7H4v3H1v2h3v3h2v-3h3v-2z",
    transform: "translate(-1 -2.275)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TB-APP_icon_Tessa",
    transform: "translate(10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_367",
    "data-name": "Group 367",
    transform: "translate(9.75 6.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_366",
    "data-name": "Group 366",
    style: {
      clipPath: "url(#clip-path)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_365",
    "data-name": "Group 365",
    transform: "translate(-16.75 -13.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_364",
    "data-name": "Group 364",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_234",
    "data-name": "Rectangle 234",
    className: "cls-2",
    transform: "translate(11.75 8.75)",
    d: "M0 0h11.974v11.914H0z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_371",
    "data-name": "Group 371",
    transform: "translate(3.75 6.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_370",
    "data-name": "Group 370",
    style: {
      clipPath: "url(#clip-path-3)"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_369",
    "data-name": "Group 369",
    transform: "translate(-10.75 -13.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_368",
    "data-name": "Group 368",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_236",
    "data-name": "Rectangle 236",
    className: "cls-2",
    transform: "translate(5.75 8.75)",
    d: "M0 0h11.974v11.914H0z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_375",
    "data-name": "Group 375",
    transform: "translate(0 8.185)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_374",
    "data-name": "Group 374",
    style: {
      clipPath: "url(#clip-path-5)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_373",
    "data-name": "Group 373",
    transform: "translate(-7 -15.185)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_372",
    "data-name": "Group 372",
    style: {
      clipPath: "url(#clip-path-6)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_238",
    "data-name": "Rectangle 238",
    className: "cls-2",
    transform: "translate(2 10.185)",
    d: "M0 0h24.26v19.264H0z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_379",
    "data-name": "Group 379",
    transform: "translate(.75 .75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_378",
    "data-name": "Group 378",
    style: {
      clipPath: "url(#clip-path-7)"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_377",
    "data-name": "Group 377",
    transform: "translate(-7.75 -7.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_376",
    "data-name": "Group 376",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_240",
    "data-name": "Rectangle 240",
    className: "cls-2",
    transform: "translate(2.75 2.75)",
    d: "M0 0h15.056v15.5H0z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_383",
    "data-name": "Group 383",
    transform: "translate(10.5 .75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_382",
    "data-name": "Group 382",
    style: {
      clipPath: "url(#clip-path-9)"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_381",
    "data-name": "Group 381",
    transform: "translate(-17.5 -7.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_380",
    "data-name": "Group 380",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_242",
    "data-name": "Rectangle 242",
    className: "cls-2",
    transform: "translate(12.5 2.75)",
    d: "M0 0h13.628v15.344H0z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_387",
    "data-name": "Group 387",
    transform: "translate(4.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_386",
    "data-name": "Group 386",
    style: {
      clipPath: "url(#clip-path-11)"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_385",
    "data-name": "Group 385",
    transform: "translate(-11.5 -7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_384",
    "data-name": "Group 384",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_244",
    "data-name": "Rectangle 244",
    className: "cls-2",
    transform: "translate(6.5 2)",
    d: "M0 0h15.6v12.528H0z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_391",
    "data-name": "Group 391",
    transform: "translate(6.75 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_390",
    "data-name": "Group 390",
    style: {
      clipPath: "url(#clip-path-13)"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_389",
    "data-name": "Group 389",
    transform: "translate(-13.75 -10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_388",
    "data-name": "Group 388",
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_246",
    "data-name": "Rectangle 246",
    className: "cls-2",
    transform: "translate(8.75 5)",
    d: "M0 0h15.552v13.669H0z"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTbAppIconAddRobot, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tb_app_icon_add_robot.5ed6c5d7.svg";
export { ForwardRef as ReactComponent };